import React from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import FormPasswordRegisterOrUpdate from "../FormPasswordRegisterOrUpdate";

export default function NewPasswordModal({
  handleClose,
  showNewPassword,
  resetPassword,
  loader2,
  passwordShow,
  pwd,
  setPwd,
  handlePasswordShow,
  pwdConfirm,
  setPwdConfirm,
  handleInputChange,
  errorResetPassword,
  successMessage,
  handleModalHide,
}) {
  return (
    <Modal
      show={showNewPassword}
      size="lg"
      onHide={() => handleModalHide()}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Nouveau mot de passe - Mot de passe oublié</Modal.Title>
      </Modal.Header>
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          resetPassword();
        }}
      >
        <Modal.Body>
          {loader2 ? (
            <div className="text-center">
              <Spinner
                animation={loader2 ? "border" : false}
                role="status"
              ></Spinner>
            </div>
          ) : (
            <div className="row">
              <div className="col-md-12">
                <Form.Group className="mb-3" controlId={`reset-new-password`}>
                  <FormPasswordRegisterOrUpdate
                    passwordShow={passwordShow}
                    controlFormId={"reset-new-password"}
                    pwd={pwd}
                    setPwd={setPwd}
                    handlePasswordShow={handlePasswordShow}
                    errorPassword={errorResetPassword}
                    setPwdConfirm={setPwdConfirm}
                    pwdConfirm={pwdConfirm}
                    handleInputChange={handleInputChange}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Text className="text-success">
                    {successMessage}
                  </Form.Text>
                </Form.Group>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="is-bottom-right">
          <Button
            variant="secondary"
            onClick={() => {
              handleClose();
            }}
          >
            Annuler
          </Button>
          <Button
            variant="success"
            type="submit"
            disabled={
              pwd.length === 0 || pwdConfirm.length === 0 ? true : false
            }
          >
            Valider
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
